<template>
    <div>
        <div>{{ $t('userComponent.greeting', [userStore.userName]) }}</div>
    </div>
</template>


<script setup lang="ts">
     import { useUserStore } from '@/stores/userStore'
     const userStore = useUserStore()
     userStore.ensureLoaded()
 </script>
